import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom"
import BackArrowTitle from "../../UI/BackArrowTitle";
import CurriculumCard from "./CurriculumCard";
import classes from "./Curriculums.module.css"
import * as PathRouter from '../../../models/PathRoute';
import { getCoursesData } from "../../../store/discipline-action";
import ScrollLTR from "../../lms-shared/UI/ScrollLTR";
import { selectDisciplinesCurrentYear } from "../../../store/discipline-slice";


const Curriculums = () => {

    const { texts } = useSelector(state => state.translate);
    const disciplines = useSelector(state => selectDisciplinesCurrentYear(state))
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const homeUrl = useSelector(state => state.application.homeUrl);
    const applicationId = useSelector(state => state.application.applicationId);


    useEffect(() => {
        if (!disciplines && applicationId)
            dispatch(getCoursesData());
    }, [applicationId])

    return <div className={classes.Curriculums}>
        <BackArrowTitle text={texts.dashboardCurriculum} onClick={() => navigate(homeUrl)}></BackArrowTitle>
        <ScrollLTR dropStyle={{ height: "calc(100vh - 240px)" }}>
            <div className={classes.CurriculumsWrap}>
                {disciplines && disciplines.filter(x => x.active).map(c => <Link key={c.id} to={`../${PathRouter.CURRICULUM}/${c.id}`}><CurriculumCard {...c} backgroundImage={`${c.baseUrl}/${c.backgroundImage}`} key={c.id}></CurriculumCard></Link>)}
            </div>
        </ScrollLTR>
    </div>
}

export default Curriculums;